import { render, staticRenderFns } from "./testIcon.vue?vue&type=template&id=27c16fa8&"
import script from "./testIcon.vue?vue&type=script&lang=js&"
export * from "./testIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports